import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, showModalPageClass, hideModalPageClass} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import ModalMultimedia from '../../../../Partials/ModalMultimedia';

export default class AdmBeneficioCliente extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            tituloLongitud:0,
            tituloBajada:0,
            titulo1Longitud:0,
            titulo2Longitud:0,
            titulo3Longitud:0,
            titulo4Longitud:0,   
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mbcl_Icono1:"",
                mbcl_Titulo1:"",
                mbcl_Enlace1:"",
                mbcl_EnlaceExternoInterno1:false,
                mbcl_Icono2:"",
                mbcl_Titulo2:"",
                mbcl_Enlace2:"",
                mbcl_EnlaceExternoInterno2:false,
                mbcl_Icono3:"",
                mbcl_Titulo3:"",
                mbcl_Enlace3:"",
                mbcl_EnlaceExternoInterno3:false,
                mbcl_Icono4:"",
                mbcl_Titulo4:"",
                mbcl_Enlace4:"",
                mbcl_EnlaceExternoInterno4:false,
                mbcl_Titulo:"",
                mbcl_TituloBajada:"",
                mbcl_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,
                mbcl_Icono1:"",
                mbcl_Titulo1:"",
                mbcl_Enlace1:"",
                mbcl_EnlaceExternoInterno1:false,
                mbcl_Icono2:"",
                mbcl_Titulo2:"",
                mbcl_Enlace2:"",
                mbcl_EnlaceExternoInterno2:false,
                mbcl_Icono3:"",
                mbcl_Titulo3:"",
                mbcl_Enlace3:"",
                mbcl_EnlaceExternoInterno3:false,
                mbcl_Icono4:"",
                mbcl_Titulo4:"",
                mbcl_Enlace4:"",
                mbcl_EnlaceExternoInterno4:false,
                mbcl_Titulo:"",
                mbcl_TituloBajada:""
            },
            Validacion: {
                mbcl_Icono1: {
                    Error: false,                    
                },
                mbcl_Titulo1: {
                    Error: false,                    
                },
                mbcl_Enlace1: {
                    Error: false,                    
                },
                mbcl_Icono2: {
                    Error: false,                    
                },
                mbcl_Titulo2: {
                    Error: false,                    
                },
                mbcl_Enlace2: {
                    Error: false,                    
                },
                mbcl_Icono3: {
                    Error: false,                    
                },
                mbcl_Titulo3: {
                    Error: false,                    
                },
                mbcl_Enlace3: {
                    Error: false,                    
                },
                mbcl_Icono4: {
                    Error: false,                    
                },
                mbcl_Titulo4: {
                    Error: false,                    
                },
                mbcl_Enlace4: {
                    Error: false,                    
                },
                mbcl_Titulo: {
                    Error: false,                    
                },
                mbcl_TituloBajada: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mbcl_Icono1: {
                    Error: false,                    
                },
                mbcl_Titulo1: {
                    Error: false,                    
                },
                mbcl_Enlace1: {
                    Error: false,                    
                },
                mbcl_Icono2: {
                    Error: false,                    
                },
                mbcl_Titulo2: {
                    Error: false,                    
                },
                mbcl_Enlace2: {
                    Error: false,                    
                },
                mbcl_Icono3: {
                    Error: false,                    
                },
                mbcl_Titulo3: {
                    Error: false,                    
                },
                mbcl_Enlace3: {
                    Error: false,                    
                },
                mbcl_Icono4: {
                    Error: false,                    
                },
                mbcl_Titulo4: {
                    Error: false,                    
                },
                mbcl_Enlace4: {
                    Error: false,                    
                },
                mbcl_Titulo: {
                    Error: false,                    
                },
                mbcl_TituloBajada: {
                    Error: false,                    
                }
            },
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:""
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
    }

    getResponseMultimedia = (urlSeleccionada) => {

        let resource = this.state.isEditfieldReturnMultimedia ? this.state.resourceEdit : this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
            
            if(this.state.isEditfieldReturnMultimedia){
                this.setState({resourceEdit:resource, fieldReturnMultimedia:"", isEditfieldReturnMultimedia:false});
            }else{
                this.setState({resource:resource, fieldReturnMultimedia:""});
            }
        }
    
        hideModalPageClass("divGestorArchivosBenCliente");
    }
    
    showModalMultimedia = (clase = "", campo = "", isEdition = false) => {
        this.setState({fieldReturnMultimedia:campo, isEditfieldReturnMultimedia:isEdition});
        showModalPageClass(clase);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let tituloBajada = this.state.tituloBajada;
        let titulo1Longitud = this.state.titulo1Longitud;
        let titulo2Longitud = this.state.titulo2Longitud;
        let titulo3Longitud = this.state.titulo3Longitud;
        let titulo4Longitud = this.state.titulo4Longitud;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mbcl_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mbcl_TituloBajada'){
            tituloBajada = value.length;
        }
        if(target.name == 'mbcl_Titulo1'){
            titulo1Longitud = value.length;
        }
        if(target.name == 'mbcl_Titulo2'){
            titulo2Longitud = value.length;
        }
        if(target.name == 'mbcl_Titulo3'){
            titulo3Longitud = value.length;
        }
        if(target.name == 'mbcl_Titulo4'){
            titulo4Longitud = value.length;
        }

        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            tituloBajada: tituloBajada,
            titulo1Longitud:titulo1Longitud,
            titulo2Longitud: titulo2Longitud,
            titulo3Longitud: titulo3Longitud,
            titulo4Longitud: titulo4Longitud,
            Validacion: validaciones
        });  
    }

    checkedValidate = (item, isEdition = false) => {

        if(isEdition)
        {
            let resource = this.state.resourceEdit;
            resource[item] = !resource[item];
    
            this.setState({resourceEdit:resource});
        }else{
            let resource = this.state.resource;
            resource[item] = !resource[item];

            this.setState({resource:resource});
        }
        
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let tituloBajada = this.state.tituloBajada;
        let titulo1Longitud = this.state.titulo1Longitud;
        let titulo2Longitud = this.state.titulo2Longitud;
        let titulo3Longitud = this.state.titulo3Longitud;
        let titulo4Longitud = this.state.titulo4Longitud;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mbcl_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mbcl_TituloBajada'){
            tituloBajada = value.length;
        }
        if(target.name == 'mbcl_Titulo1'){
            titulo1Longitud = value.length;
        }
        if(target.name == 'mbcl_Titulo2'){
            titulo2Longitud = value.length;
        }
        if(target.name == 'mbcl_Titulo3'){
            titulo3Longitud = value.length;
        }
        if(target.name == 'mbcl_Titulo4'){
            titulo4Longitud = value.length;
        }

        this.setState({
            resourceEdit: copyResource,
            tituloLongitud: tituloLongitud,
            tituloBajada: tituloBajada,
            titulo1Longitud:titulo1Longitud,
            titulo2Longitud: titulo2Longitud,
            titulo3Longitud: titulo3Longitud,
            titulo4Longitud: titulo4Longitud,
            ValidacionEdit: validaciones
        });  
    }

    storeBeneficioCliente = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mbcl_Icono1 == '') {              
            newState.Validacion.mbcl_Icono1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mbcl_Titulo1 == '') {  
            newState.Validacion.mbcl_Titulo1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mbcl_Icono2 == '') {  
            newState.Validacion.mbcl_Icono2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mbcl_Titulo2 == '') {  
            newState.Validacion.mbcl_Titulo2 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resource.mbcl_Icono3 == '') {  
            newState.Validacion.mbcl_Icono3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mbcl_Titulo3 == '') {              
            newState.Validacion.mbcl_Titulo3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mbcl_Icono4 == '') {  
            newState.Validacion.mbcl_Icono4 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resource.mbcl_Titulo4 == '') {              
            newState.Validacion.mbcl_Titulo4 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mbcl_Titulo == '') {              
            newState.Validacion.mbcl_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mbcl_TituloBajada == '') {  
            newState.Validacion.mbcl_TituloBajada = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloBeneficioClienteUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mbcl_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.mbcl_Icono1 = '';
                stateResponse.resource.mbcl_Titulo1 = '';
                stateResponse.resource.mbcl_Enlace1 = '';
                stateResponse.resource.mbcl_EnlaceExternoInterno1 = false;
                stateResponse.resource.mbcl_Icono2 = '';
                stateResponse.resource.mbcl_Titulo2 = '';
                stateResponse.resource.mbcl_Enlace2 = '';
                stateResponse.resource.mbcl_EnlaceExternoInterno2 = false;
                stateResponse.resource.mbcl_Icono3 = '';
                stateResponse.resource.mbcl_Titulo3 = '';
                stateResponse.resource.mbcl_Enlace3 = '';
                stateResponse.resource.mbcl_EnlaceExternoInterno3 = false;
                stateResponse.resource.mbcl_Icono4 = '';
                stateResponse.resource.mbcl_Titulo4 = '';
                stateResponse.resource.mbcl_Enlace4 = '';
                stateResponse.resource.mbcl_EnlaceExternoInterno4 = false;
                stateResponse.resource.mbcl_Titulo = "";
                stateResponse.resource.mbcl_TituloBajada = "";

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateBeneficioCliente = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mbcl_Icono1 == '') {              
            newState.ValidacionEdit.mbcl_Icono1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mbcl_Titulo1 == '') {  
            newState.ValidacionEdit.mbcl_Titulo1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mbcl_Icono2 == '') {  
            newState.ValidacionEdit.mbcl_Icono2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mbcl_Titulo2 == '') {  
            newState.ValidacionEdit.mbcl_Titulo2 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resourceEdit.mbcl_Icono3 == '') {  
            newState.ValidacionEdit.mbcl_Icono3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mbcl_Titulo3 == '') {              
            newState.ValidacionEdit.mbcl_Titulo3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mbcl_Icono4 == '') {  
            newState.ValidacionEdit.mbcl_Icono4 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resourceEdit.mbcl_Titulo4 == '') {              
            newState.ValidacionEdit.mbcl_Titulo4 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mbcl_Titulo == '') {              
            newState.ValidacionEdit.mbcl_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mbcl_TituloBajada == '') {  
            newState.ValidacionEdit.mbcl_TituloBajada = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloBeneficioClienteUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mbcl_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closeBeneficioCliente = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;

        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mbcl_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }

     

    loadDetallePerfilador = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloBeneficioClienteUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resourceEdit: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){

        let mweb = 4;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadDetallePerfilador(resource.pmod_Id);
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeBeneficioCliente()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">

                        {
                            this.state.resourceEdit.mbcl_Id > 0 ?
                            <React.Fragment>
                            <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                

                                <div className="txtFile x-1">
                                    <input type="text" 
                                    placeholder="Título" 
                                    name='mbcl_Titulo' 
                                    value={this.state.resourceEdit.mbcl_Titulo} 
                                    maxLength={10} 
                                    className={this.state.ValidacionEdit.mbcl_Titulo.Error ? "error" : ""}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={10}>{this.state.tituloLongitud}/10</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Resumen" 
                                    name='mbcl_TituloBajada' 
                                    value={this.state.resourceEdit.mbcl_TituloBajada} 
                                    className={this.state.ValidacionEdit.mbcl_TituloBajada.Error ? "error" : ""} 
                                    maxLength={15}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={15}>{this.state.tituloBajada}/15</span>
                                </div>

                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Titulo 1" 
                                    name='mbcl_Titulo1' 
                                    value={this.state.resourceEdit.mbcl_Titulo1} 
                                    className={this.state.ValidacionEdit.mbcl_Titulo1.Error ? "error" : ""} 
                                    maxLength={50}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={50}>{this.state.titulo1Longitud}/50</span>
                                </div>
                                

                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBenCliente", "mbcl_Icono1", true)}/>
                                    <input type="text" placeholder="Icono 1" 
                                    name='mbcl_Icono1' 
                                    value={this.state.resourceEdit.mbcl_Icono1} 
                                    className={this.state.ValidacionEdit.mbcl_Icono1.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 35px de ancho X 35px de alto.</label>
                                </div>


                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Titulo 2" 
                                    name='mbcl_Titulo2' 
                                    value={this.state.resourceEdit.mbcl_Titulo2} 
                                    className={this.state.ValidacionEdit.mbcl_Titulo2.Error ? "error" : ""} 
                                    maxLength={50}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={50}>{this.state.titulo2Longitud}/50</span>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBenCliente", "mbcl_Icono2", true)}/>
                                    <input type="text" placeholder="Icono 2" 
                                    name='mbcl_Icono2' 
                                    value={this.state.resourceEdit.mbcl_Icono2} 
                                    className={this.state.ValidacionEdit.mbcl_Icono2.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 35px de ancho X 35px de alto.</label>
                                </div>

                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Titulo 3" 
                                    name='mbcl_Titulo3' 
                                    value={this.state.resourceEdit.mbcl_Titulo3} 
                                    className={this.state.ValidacionEdit.mbcl_Titulo3.Error ? "error" : ""} 
                                    maxLength={50}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={50}>{this.state.titulo3Longitud}/50</span>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBenCliente", "mbcl_Icono3", true)}/>
                                    <input type="text" placeholder="Icono 3" 
                                    name='mbcl_Icono3' 
                                    value={this.state.resourceEdit.mbcl_Icono3} 
                                    className={this.state.ValidacionEdit.mbcl_Icono3.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 35px de ancho X 35px de alto.</label>
                                </div>

                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Titulo 4" 
                                    name='mbcl_Titulo4' 
                                    value={this.state.resourceEdit.mbcl_Titulo4} 
                                    className={this.state.ValidacionEdit.mbcl_Titulo4.Error ? "error" : ""} 
                                    maxLength={50}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={50}>{this.state.titulo3Longitud}/50</span>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBenCliente", "mbcl_Icono4", true)}/>
                                    <input type="text" placeholder="Icono 4" 
                                    name='mbcl_Icono4' 
                                    value={this.state.resourceEdit.mbcl_Icono4} 
                                    className={this.state.ValidacionEdit.mbcl_Icono4.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 35px de ancho X 35px de alto.</label>
                                </div>



                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resourceEdit.pmod_ClaseAncla}  
                                                onChange={this.handleInputChangeEdit}/>
                                            </div>	

                                            <div className="txtFile x-1">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChangeEdit} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} selected={(this.state.resourceEdit.pmod_Pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChangeEdit} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id} selected={(this.state.resourceEdit.pmod_Sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>



                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateBeneficioCliente(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    <div className="txtFile x-1">
                                        <input type="text" 
                                        placeholder="Título" 
                                        name='mbcl_Titulo' 
                                        value={this.state.resource.mbcl_Titulo} 
                                        maxLength={10} 
                                        className={this.state.Validacion.mbcl_Titulo.Error ? "error" : ""}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={10}>{this.state.tituloLongitud}/10</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Resumen" 
                                        name='mbcl_TituloBajada' 
                                        value={this.state.resource.mbcl_TituloBajada} 
                                        className={this.state.Validacion.mbcl_TituloBajada.Error ? "error" : ""} 
                                        maxLength={15}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={15}>{this.state.tituloBajada}/15</span>
                                    </div>

                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Titulo 1" 
                                        name='mbcl_Titulo1' 
                                        value={this.state.resource.mbcl_Titulo1} 
                                        className={this.state.Validacion.mbcl_Titulo1.Error ? "error" : ""} 
                                        maxLength={50}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={50}>{this.state.titulo1Longitud}/50</span>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBenCliente", "mbcl_Icono1")}/>
                                        <input type="text" placeholder="Icono 1" 
                                        name='mbcl_Icono1' 
                                        value={this.state.resource.mbcl_Icono1} 
                                        className={this.state.Validacion.mbcl_Icono1.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 35px de ancho X 35px de alto.</label>
                                    </div>


                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Titulo 2" 
                                        name='mbcl_Titulo2' 
                                        value={this.state.resource.mbcl_Titulo2} 
                                        className={this.state.Validacion.mbcl_Titulo2.Error ? "error" : ""} 
                                        maxLength={50}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={50}>{this.state.titulo2Longitud}/50</span>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBenCliente", "mbcl_Icono2")}/>
                                        <input type="text" placeholder="Icono 2" 
                                        name='mbcl_Icono2' 
                                        value={this.state.resource.mbcl_Icono2} 
                                        className={this.state.Validacion.mbcl_Icono2.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 35px de ancho X 35px de alto.</label>
                                    </div>

                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Titulo 3" 
                                        name='mbcl_Titulo3' 
                                        value={this.state.resource.mbcl_Titulo3} 
                                        className={this.state.Validacion.mbcl_Titulo3.Error ? "error" : ""} 
                                        maxLength={50}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={50}>{this.state.titulo3Longitud}/50</span>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBenCliente", "mbcl_Icono3")}/>
                                        <input type="text" placeholder="Icono 3" 
                                        name='mbcl_Icono3' 
                                        value={this.state.resource.mbcl_Icono3} 
                                        className={this.state.Validacion.mbcl_Icono3.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 35px de ancho X 35px de alto.</label>
                                    </div>

                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Titulo 4" 
                                        name='mbcl_Titulo4' 
                                        value={this.state.resource.mbcl_Titulo4} 
                                        className={this.state.Validacion.mbcl_Titulo4.Error ? "error" : ""} 
                                        maxLength={50}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={50}>{this.state.titulo3Longitud}/50</span>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosBenCliente", "mbcl_Icono4")}/>
                                        <input type="text" placeholder="Icono 4" 
                                        name='mbcl_Icono4' 
                                        value={this.state.resource.mbcl_Icono4} 
                                        className={this.state.Validacion.mbcl_Icono4.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 35px de ancho X 35px de alto.</label>
                                    </div>



                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resource.pmod_ClaseAncla}  
                                                onChange={this.handleInputChange}/>
                                            </div>	

                                            <div className="txtFile x-1">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>






                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeBeneficioCliente(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                        
                        

                    </div>
                    </div>
                </div>
                <ModalMultimedia class="divGestorArchivosBenCliente" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}
